import { useState } from "react";
import BlurText from "./BlurText";
import type { CompanyType } from "@/types/company";
import { useNavigate } from "react-router-dom";

interface CompanyProps {
  company: CompanyType;
}

export default function Company({ company }: CompanyProps) {
  const [isOnHover, setIsOnHover] = useState(false);
  const navigate = useNavigate();
  const isOpen = (company: CompanyType): { open: boolean; untill: string } => {
    const now = new Date();
    const day = now.getDay();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    const currentTime = hours * 100 + minutes;

    const [openTime, closeTime] = company.workingHours[day];
    console.log(openTime, closeTime, currentTime);

    if (!openTime) return { open: false, untill: "" };
    if (!closeTime) return { open: true, untill: "" };

    return {
      open: currentTime >= openTime && currentTime <= closeTime,
      untill: `${(closeTime / 100).toString().padStart(2, "0")}:${(
        closeTime % 100
      )
        .toString()
        .padStart(2, "0")}`,
    };
  };

  const open = isOpen(company);

  return (
    <div
      className="flex flex-col rounded-lg cursor-pointer transition-all duration-300 gap-3 sm:gap-4"
      onMouseEnter={() => setIsOnHover(true)}
      onMouseLeave={() => setIsOnHover(false)}
      onClick={() => {
        navigate(`/restaurants/${company.id}`);
      }}
    >
      <div className="w-full h-48 sm:h-60 lg:h-64 relative">
        <img
          src={company.image}
          className={`w-full h-full object-cover rounded-xl transition-all duration-300 ${
            isOnHover ? "scale-105" : ""
          }`}
        />
        <div
          className={`absolute transition-all duration-300 bg-green-500 text-white px-2 py-1 rounded-full text-xs font-semibold flex flex-row gap-1 ${
            isOnHover ? "top-0.5 left-0.5" : "top-2 left-2"
          }`}
        >
          <span>{open ? "open" : "closed"}</span>
          {/* {isOnHover && (
            <BlurText
              direction="bottom"
              text={`untill ${open.untill}`}
              animateBy="words"
              onAnimationComplete={() => {}}
            />
          )} */}
        </div>
      </div>
      <h3 className="text-base sm:text-lg px-1 sm:px-2 py-1 rounded-lg w-fit font-semibold transition-all duration-300">
        {company.name}
      </h3>
    </div>
  );
}
